module.exports = __webpack_public_path__ + "static/media/imageCropping.3c696cf3.svg";